import { render, staticRenderFns } from "./MeasurementsForm.vue?vue&type=template&id=25707665&scoped=true&"
import script from "./MeasurementsForm.vue?vue&type=script&lang=js&"
export * from "./MeasurementsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25707665",
  null
  
)

export default component.exports